import { render } from "./UserCrud.vue?vue&type=template&id=a75e65d2&bindings={\"state\":\"setup\",\"next\":\"setup\",\"prev\":\"setup\",\"destroy\":\"setup\",\"addUser\":\"setup\"}"
import script from "./UserCrud.vue?vue&type=script&lang=js"
export * from "./UserCrud.vue?vue&type=script&lang=js"
script.render = render

export default script